import {
    HomeIcon,
    OfficeBuildingIcon,
    UsersIcon,
    CalendarIcon,
    TicketIcon,
    CashIcon,
    BellIcon,
    SparklesIcon,
    CalculatorIcon,
    ViewListIcon,
    MailIcon,
    SpeakerphoneIcon,
    CodeIcon,
    AdjustmentsIcon,
    ShieldCheckIcon,
    ChipIcon,
} from '@heroicons/react/outline';
import {
    HomeIcon as HomeIconSolid,
    OfficeBuildingIcon as OfficeBuildingIconSolid,
    UsersIcon as UsersIconSolid,
    CalendarIcon as CalendarIconSolid,
    TicketIcon as TicketIconSolid,
    CashIcon as CashIconSolid,
    BellIcon as BellIconSolid,
    SparklesIcon as SparklesIconSolid,
    CalculatorIcon as CalculatorIconSolid,
    ViewListIcon as ViewListIconSolid,
    MailIcon as MailIconSolid,
    SpeakerphoneIcon as SpeakerphoneIconSolid,
    CodeIcon as CodeIconSolid,
    AdjustmentsIcon as AdjustmentsIconSolid,
    ShieldCheckIcon as ShieldCheckIconSolid,
    ChipIcon as ChipIconSolid,
} from '@heroicons/react/solid';

// TODO: combine CustomLink and getIconForRoute in one component

export function getIconForRoute(route: string) {
    switch (route) {
        case '/':
            return [HomeIcon, HomeIconSolid];

        case '/companies':
            return [OfficeBuildingIcon, OfficeBuildingIconSolid];

        case '/users':
            return [UsersIcon, UsersIconSolid];

        case '/customers':
            return [UsersIcon, UsersIconSolid];

        case '/bookings':
            return [CalendarIcon, CalendarIconSolid];

        case '/tickets':
            return [TicketIcon, TicketIconSolid];

        case '/invoicing':
            return [CashIcon, CashIconSolid];

        case '/incentives':
            return [BellIcon, BellIconSolid];

        case '/actions':
            return [SparklesIcon, SparklesIconSolid];

        case '/mailchimp':
            return [MailIcon, MailIconSolid];

        case '/newsletter':
            return [SpeakerphoneIcon, SpeakerphoneIconSolid];

        case '/voss':
            return [CalculatorIcon, CalculatorIconSolid];

        case '/errorlogs':
            return [ViewListIcon, ViewListIconSolid];

        case '/licensechangeslog':
            return [ViewListIcon, ViewListIconSolid];

        case '/widget/configuration-schemas':
            return [CodeIcon, CodeIconSolid];

        case '/feature-flags':
            return [AdjustmentsIcon, AdjustmentsIconSolid];

        case '/assistant-usage':
            return [ChipIcon, ChipIconSolid];

        case '/redirect-domains':
            return [ShieldCheckIcon, ShieldCheckIconSolid];

        default:
            return [];
    }
}
